import { render, staticRenderFns } from "./EmbeddedMedia.vue?vue&type=template&id=0553ae3c&"
import script from "./EmbeddedMedia.vue?vue&type=script&lang=js&"
export * from "./EmbeddedMedia.vue?vue&type=script&lang=js&"
import style0 from "./EmbeddedMedia.vue?vue&type=style&index=0&id=0553ae3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports